import { UserInfoScreen } from '@/screens/index'

export default function () {
  return <UserInfoScreen />
}
